import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { importConfigs } from "./importConfigs";

function ImportModal({
  show,
  handleClose,
  type,
  onSuccess,
}) {

  const config = importConfigs[type]; // auto config

  const [selectedFile, setSelectedFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = async () => {

    if (!selectedFile) {
      toast.error("Please select a file to import");
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {

      const response = await axios.post(
        `${BASE_URL}${config.importUrl}`,
        formData,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data?.message) {
        toast.success(response.data.message);
      }

      onSuccess?.();
      handleClose();

    } catch (error) {

      if (
        error.response &&
        Array.isArray(error.response.data?.errors)
      ) {

        error.response.data.errors.forEach((err) => {
          Object.entries(err).forEach(([key, message]) => {
            toast.error(`${key}: ${message}`);
          });
        });

      } else {
        toast.error("Failed to import data");
      }

      console.error(error);

    } finally {
      setIsSubmitting(false);
    }
  };

  if (!config) return null; // safety

  return (
    <Modal show={show} onHide={handleClose} centered>

      <Modal.Header closeButton>
        <Modal.Title>Import Data</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <p className="small mb-3 text-center">
          <a
            href={`${BASE_URL}${config.downloadUrl}`}
            download
            className="download-link"
          >
            Click Here
          </a>{" "}
          to download sample excel file.
        </p>

        <div className="import-content border rounded p-3 d-flex justify-content-between">

          <div className="file-upload-section d-flex flex-column align-items-center justify-content-center">

            <FontAwesomeIcon
              icon={faFileExcel}
              size="3x"
              className="mb-2 text-success"
            />

            <Button
              variant="outline-secondary"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Choose File
            </Button>

            <input
              type="file"
              id="fileInput"
              className="d-none"
              onChange={handleFileChange}
            />

            {selectedFile && <p className="mt-2">{selectedFile.name}</p>}

          </div>

          <div className="rules-section border rounded p-3 ml-3">

            <h6 className="text-center">Rules</h6>
            <hr />

            {config.compulsoryFields?.length > 0 && (
              <>
                <strong>Compulsory Fields</strong>
                <ul>
                  {config.compulsoryFields.map((field, index) => (
                    <li key={index}>{field}</li>
                  ))}
                </ul>
              </>
            )}

            {config.optionalFields?.length > 0 && (
              <>
                <strong>Optional Fields</strong>
                <ul>
                  {config.optionalFields.map((field, index) => (
                    <li key={index}>{field}</li>
                  ))}
                </ul>
              </>
            )}

          </div>

        </div>

      </Modal.Body>

      <Modal.Footer>

        <Button
          variant="secondary"
          onClick={handleClose}
          disabled={isSubmitting}
        >
          Close
        </Button>

        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <Spinner animation="border" size="sm" />
          ) : (
            "Submit"
          )}
        </Button>

      </Modal.Footer>

    </Modal>
  );
}

export default ImportModal;